
<div class="declaration mt-2 flex justify-content-center flex-wrap">
    <strong class="text-lg">Per qualunque informazione potrete contattare il numero della Segreteria 3534613879 o il Responsabile delle convenzioni Lorenzo Sichi, al numero 3288811604.</strong>
</div>
<p-scrollPanel [style]="{ width: '100%', height: 'calc(100% - 120px)' }">
    <div class="grid m-0 mt-3 gap-4">
        <p-button
            
            [style]="{
                'width': '16rem',
                'height': '11rem'
            }" 
            [outlined]="true" 
            [rounded]="false" >
            <div>
                <div class="font-bold">
                    Codice convenzione
                </div>
                <ngx-barcode6
                    [bc-format]="'CODE128'"
                    [bc-display-value]="false"
                    [bc-value]="code"
                    [bc-font]="'Inter var, sans-serif'"
                    [bc-font-size]="28"
                    [bc-display-value]="true"
                    [bc-line-color]="'#2563eb'"
                    [bc-background]="'#00000000'"
                    [bc-height]="56"
                >
                </ngx-barcode6>
            </div>
        </p-button>
        <ng-container *ngFor="let agreement of agreements; index as index">
            <p-button
                [style]="{
                    'width': '16rem',
                    'height': '11rem',
                    'color': agreement.flagColor,
                    'position': 'relative'
                }" 
                [badge]="agreement.flagDescription"
                [outlined]="true" 
                [rounded]="false" 
                [label]="agreement.jobType"
                (onClick)="!agreement.disabled? selectDetails(agreement): undefined">

            <div style="width: 12px; height: 12px; border-radius: 50%; position: absolute; top: 6px; right: 6px;" [style]="{
                'background-color': agreement.disabled? '#ef4444': '#22c55e'
            }"></div>
            </p-button>
            
            <!-- <p-card [style]="{ width: '360px'}" class="mr-3 mb-3">
    
                <ng-template pTemplate="title">
                    <div class="p-card-title">{{agreement.name}} {{agreement.lastName}}</div>
                    
                </ng-template>
                <ng-template pTemplate="subtitle">
                    <div class="p-card-subtitle">{{agreement.description}}</div>
                </ng-template>
                <ng-template pTemplate="content">
                    <div class="agreement-notes">{{agreement.notes}}</div>
                </ng-template>
            </p-card> -->
        </ng-container>
    </div>
</p-scrollPanel>
<p-dialog [draggable]="false" [modal]="true" [closable]="false" [style]="{'width': fileSrc !== null && fileSrc !== undefined && fileSrc !==''? '100%':'auto'}" [visible]="selectedNodes !== null" position="center">
    <ng-template pTemplate="header">
        <div class="flex justify-content-between flex-wrap gap-1 w-full">
            <div>
                <h3>{{selectedNodes?.jobType}}</h3>
                <h4 class="mb-0">{{name}}</h4>
            </div>
            <p-button icon="pi pi-times" (onClick)="onDetailClosed()" [outlined]="true" severity="secondary"></p-button>
        </div>
    </ng-template>
    <ng-template pTemplate="message">
        <div class="mb-3" *ngIf="(selectedNodes!.phone && selectedNodes!.phone !== null && selectedNodes!.phone !== '') || (selectedNodes!.email && selectedNodes!.email !== null && selectedNodes!.email !== '')">
            <div *ngIf="selectedNodes!.email && selectedNodes!.email !== null && selectedNodes!.email !== ''">
                <span>Email: <strong>{{selectedNodes!.email}}</strong></span>
            </div>
            <div *ngIf="selectedNodes!.phone && selectedNodes!.phone !== null && selectedNodes!.phone !== ''">
                <span>Telefono: <strong>{{selectedNodes!.phone}}</strong></span>
            </div>
        </div>
        <ng-container *ngIf="selectedNodes!.notes !== null && selectedNodes!.notes !== undefined && selectedNodes!.notes !==''">
            <div class="agreement-notes">{{selectedNodes?.notes}}</div>
        </ng-container>
        <ng-container *ngIf="fileSrc !== null && fileSrc !== undefined && fileSrc !==''">
            <div class="mt-1">
                <ngx-extended-pdf-viewer 
                    [enablePrint]="false"
                    [showToolbar]="false"
                    [enableDragAndDrop]="false"
                    [handTool]="false"
                    [src]="fileSrc">
                </ngx-extended-pdf-viewer>
            </div>
        </ng-container>
    </ng-template>
    <ng-template pTemplate="footer">
    </ng-template>
</p-dialog>